import React from "react";
import { ShivInfotech } from "../../Constant/index";
import { Link } from "react-router-dom";

const Footer = () => (
  <>
    <p className="mb-0" style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>
      Copyright 2024 ©{" "}
      <Link
        to="https://shivinfotech.co/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "var(--brand-indigo)", fontWeight: 600 }}
      >
        {ShivInfotech}
      </Link>{" "}
      All rights reserved.
    </p>
    <p className="mb-0" style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>
      Made with <span style={{ color: "var(--danger)" }}>♥</span> by the team
    </p>
  </>
);

export default Footer;
